import { Component, OnInit } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { SidebarService } from './sidebar.service';
import { TMenuItem, TMenuCanActiveItem } from './sidebar.interfaces';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('slide', [
      state('up', style({ height: 0 })),
      state('down', style({ height: '*' })),
      transition('up <=> down', animate(200)),
    ]),
  ],
})
export class SidebarComponent implements OnInit {
  menu: TMenuItem[] = [];

  constructor(private sidebarservice: SidebarService) {
    sidebarservice.getMenuObservable().subscribe((menu) => {
      this.menu = menu;
    });
  }

  ngOnInit() {}

  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  toggle(currentMenu: TMenuCanActiveItem) {
    if (currentMenu.type === 'dropdown') {
      this.menu.forEach((element) => {
        if (element === currentMenu) {
          currentMenu.active = !currentMenu.active;
        }
      });
    }
  }

  getState(currentMenu: TMenuCanActiveItem) {
    if (currentMenu.active) {
      return 'down';
    } else {
      return 'up';
    }
  }

  hasBackgroundImage() {
    return this.sidebarservice.hasBackgroundImage;
  }
}
